var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-10 h-10 grid justify-center items-center rounded-full",class:{
    'bg-gray-500 text-white': _vm.status === 'missed',
    'text-primary-500 border-2 border-primary-500': _vm.status === 'checked',
    'text-gray-400 border-2 border-gray-400': _vm.status === 'ongoing',
    }},[_c('div',{staticClass:"font-medium"},[(_vm.status !== 'checked')?_c('span',[_vm._v(_vm._s(_vm.day))]):_c('span',[_c('icon',{attrs:{"name":"Check","settings":{ circle: false },"size":"1.5em"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }